import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

export default class Rent extends Component{
	render(){
		let { props } = this
		return(
			<div style={{display: "flex", justifyContent: "space-between"}}>
				{
				R.map(rent => {
					return (
						<div className="rent" style={{width: "100%"}}>
							<h2 style={{color: "rgb(62, 208, 176)"}}>{rent.rentIter ? "Prior Address" : "Current Address"}</h2>
							<div className="address" style={{display:!rent.curAddr? "none" : "block"}} >
								<p><span style={{fontWeight: "bold"}}>Address:</span> {rent.curAddr}</p>
							</div>
							<div className="years" style={{display:!rent.yearCur? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Years at address:</span> {rent.yearCur}</p>
							</div>
							<div className="reason" style={{display:!rent.reason? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Reason for leaving:</span> {rent.reason}</p>
							</div>
							<div className="owning" style={{display:!rent.typeOfowning? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Own this property:</span> {rent.typeOfowning? "No" : "Yes"}</p>
							</div>
							<div className="manager-name" style={{display:!rent.managerName? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Manager name:</span> {rent.managerName}</p>
							</div>
							<div className="manager-phone" style={{display:!rent.managerPhone? "none" : "block"}}>
								<p><span style={{fontWeight: "bold"}}>Manager phone:</span> {rent.managerPhone}</p>
							</div>
						</div>
					)
				})(props.data)
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/applicationForm/Rent.js